<template>
  <a v-if="item.href" class="incremental-nav-link" :href="item.href" target="_blank" rel="noopener noreferrer" @click="$emit('navigate')">
    <span v-if="item.icon" class="material-icons-outlined incremental-nav-link__icon" aria-hidden="true">{{ item.icon }}</span>
    <span class="incremental-nav-link__label">{{ item.name }}</span>
    <span class="material-icons-outlined incremental-nav-link__external" aria-hidden="true">open_in_new</span>
    <span class="incremental-sr-only">(se abre en otra pestaña)</span>
  </a>
  <router-link v-else class="incremental-nav-link" :class="{ 'is-current': active }" :to="{ name: item.routeName }"
    :data-route="item.routeName" :aria-current="active ? 'page' : null" @click.native="$emit('navigate')">
    <span v-if="item.icon" class="material-icons-outlined incremental-nav-link__icon" aria-hidden="true">{{ item.icon }}</span>
    <span class="incremental-nav-link__label">{{ item.name }}</span>
    <span v-if="badge" class="incremental-nav-badge" :aria-label="badge + ' pendientes'">{{ badge > 99 ? '99+' : badge }}</span>
  </router-link>
</template>

<script>
import { isNavigationItemActive } from './models/incrementalNavigation';

export default {
  name: 'IncrementalNavLink',
  props: { item: { type: Object, required: true }, badge: { type: Number, default: 0 } },
  computed: { active() { return isNavigationItemActive(this.item, this.$route); } }
};
</script>
